<script setup lang="ts">
import type { Event } from '#shared/types/events'

defineProps<{
  event: Event
}>()
</script>

<template>
  <CardsEventInfoCell v-if="event.time" icon="far:clock">
    <span>{{ event.time }}</span>
  </CardsEventInfoCell>
</template>
